/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { selector } from 'apps/services';
import { Translation, withTranslation } from 'react-i18next';
import * as Sentry from '@sentry/browser';
import { Link } from 'react-router-dom';
import { MAIN_ROUTE } from 'configs/constants';
import { useParams } from 'react-router-dom';
import { getText } from 'helpers/app/getText';

function ErrorBoundary({ error }) {
  const { countrycode, pagelink } = useParams();

  return (
    <Translation ns="errors">
      {(t, { i18n }) => {
        return (
          <div className="card my-5">
            <div className="card-body">
              <div className="abs-center wd-xl">
                <div className="text-center mb-4">
                  <div className="mb-3">
                    <em className="fa fa-wrench fa-5x text-muted"></em>
                  </div>
                  <p className="lead m-0">{getText('errors:ERROR_TITLE1')}</p>
                  <p>{getText('errors:ERROR_TITLE2')}</p>
                  <p>{getText('errors:ERROR_TITLE3')}</p>
                </div>
                <ul className="list-inline text-center text-sm mb-4">
                  <li className="list-inline-item">
                    <Link to={MAIN_ROUTE(countrycode, pagelink)} className="text-muted">
                      {getText('errors:GO_TO_QUICKSHOP')}
                    </Link>
                    <br />
                    <br />
                    <button className="bg-primary text-light" onClick={() => Sentry.showReportDialog(new Error(error))}>
                      {getText('errors:REPORT_FEEDBACK')}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        );
      }}
    </Translation>
  );
}

const mapStateToProps = (state) => selector(state, false, ['app', 'authorisation']);

const mapDispatchToProps = () => {
  return {};
};

export default withTranslation('errors')(connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary));
